import classNames from "classnames";
import { IColor } from "@types";

export const createColorClass = (
  color: IColor,
  s: {
    readonly [key: string]: string;
  },
) => {
  return classNames({
    [s.LightBlue]: color === IColor.LightBlue,
    [s.LightGrey]: color === IColor.LightGrey,
  });
};
